import axios from 'axios'

export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  headers: {
    Authorization: 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJndWVzdC5ndWVzdCIsImF1dGgiOlsiU1RBTkRBUkRfVVNFUiJdfQ.otau49DOcKJLsquIysnEyvGQ8FraesG4O7OV-dgOqz3BQ8xxUIV2YJo-F4zkXezRGhrNqrw2yYg9LMeBxUAHxA'
  }
})
